import { PropsWithChildren } from 'react';
import { playSound, Sound } from '~/assets/sounds';
import { ButtonBorderRadius, IButtonProps } from './Button.model';
import { StyledButton } from './Button.styled';

const Button = ({
	color,
	height,
	borderRadius = ButtonBorderRadius.Radius10,
	children,
	onMouseEnter,
	onClick,
	mute,
	noBorder,
	noInvertImage,
	square,
	hover,
	hoverCurrencyColor = '#000000',
	...props
}: IButtonProps &
	PropsWithChildren &
	React.ButtonHTMLAttributes<HTMLButtonElement>) => {
	return (
		<StyledButton
			tabIndex={-1}
			$color={color}
			$height={height}
			$noBorder={noBorder}
			$borderRadius={borderRadius}
			$noInvertImage={noInvertImage}
			$square={square}
			$hover={hover}
			$hoverCurrencyColor={hoverCurrencyColor}
			onClick={(e) => {
				onClick?.(e);
				if (!props?.disabled && !mute) {
					playSound(Sound.ClickButton);
				}
			}}
			onMouseEnter={(e) => {
				onMouseEnter?.(e);
				if (!props?.disabled && !mute) {
					playSound(Sound.LinkCursor);
				}
			}}
			{...props}
		>
			{children}
		</StyledButton>
	);
};

export { Button };
